import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { QueryParams } from 'src/actuators/user-input/calculations/constants.ts';
import { RegionsEnum } from 'src/generated/operations.ts';
import { initInputState } from 'src/actuators/user-input/InitInputState.ts';
import { initialState, UserInput } from 'src/actuators/user-input/types.ts';

export const parseParam = (value: string): string[] => {
    try {
        const val = JSON.parse(value);
        if (Array.isArray(val) && val.length > 0) {
            return val;
        }
        return [];
    } catch {
        return [];
    }
};

export function useReadUserInput(
    searchParams: URLSearchParams,
    currentRegion: RegionsEnum,
): [FilterConfig, Filter, UserInput] {
    const state = initInputState(searchParams, initialState);

    const labels = parseParam(searchParams.get(QueryParams.labels) ?? '[]');
    if (labels.length > 0) {
        return [
            [['label', 'label']],
            { label: labels },
            state,
        ];
    }

    const torques = parseParam(searchParams.get(QueryParams.torques) ?? '[]');
    if (torques.length > 0) {
        return [
            [['torques', currentRegion === RegionsEnum.Am ? '65' : '260']],
            { torques },
            state,
        ];
    }
    const forces = parseParam(searchParams.get(QueryParams.forces) ?? '[]');
    if (forces.length > 0) {
        return [
            [['forces', currentRegion === RegionsEnum.Am ? '223' : '118']],
            { forces },
            state,
        ];
    }
    return [[], {}, state];
}
